import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Button from 'components/Button'
import Grid from '@material-ui/core/Grid'
import { Input } from 'components'
import { handleChangeForm, validateForm } from 'utils'

export default function Forms({
  sections,
  fieldsById,
  submitForm = () => null,
  hideSubmitButton = true,
  loading = false,
  error = false,
  onCancel = null,
  cancelText = `cancelar`,
  acceptText = `Enviar`,
  buttonsSize = `large`,
  buttonsFullWidth = true,
  classes = {},
  handle = () => null,
  dataForm = {},
}) {
  const [form, setForm] = useState(fieldsById)
  const [data, setData] = useState(dataForm || null)
  const [isValid, setIsValid] = useState(false)

  function setInputValue(name) {
   
    return function setValue({ value }) {
      
      const nextForm = handleChangeForm(form, name, value)
      value = nextForm[name]?.value ? nextForm[name].value : null
      setForm(nextForm)
      setData({ ...data, [name]: value })
      handle(nextForm, { ...data, [name]: value }, name)
    }
  }
  useEffect(() => {
    const nextIsValid = validateForm(form)
    setIsValid(nextIsValid)
  }, [form])

  // eslint-disable-next-line
  return (
    <Grid container alignItems="flex-start" alignContent="flex-start">
      <Grid container key={`regular-section`} alignItems="flex-start" alignContent="flex-start">
        {sections.map((fieldId, index) => (
          <Input
            {...form[fieldId]}
            id={fieldId}
            fieldsById={fieldsById}
            valueListener={setInputValue}
            key={`input-${fieldId}-${index}`}
          />
        ))}
      </Grid>
      {hideSubmitButton && (
        <Grid container justify="center" alignItems="center" style={{ marginTop: 20 }}>
          {onCancel && (
            <Button
              className={classes.cancelButton}
              fullWidth={buttonsFullWidth}
              size={buttonsSize}
              variant="contained"
              color="secondary"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelText}
            </Button>
          )}
          <Button
            className={classes.button}
            fullWidth={buttonsFullWidth}
            size={buttonsSize}
            variant="contained"
            color="primary"
            onClick={() => submitForm(data)}
            disabled={!isValid || loading}
            loading={loading}
            classes={{ disabled: classes.disabledButton }}
          >
            {acceptText}
          </Button>
        </Grid>
      )}
      {error && error.length > 0 && (
        <Grid container item justify="center">
          <Typography color="error">{error}</Typography>
        </Grid>
      )}
    </Grid>
  )
}
